import React from 'react';
import { InView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import { clientError } from '../../lib/errorReporting';

class FirstInView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hadFirstView: false };
    this.toggleHadFirstView = this.toggleHadFirstView.bind(this);
  }

  toggleHadFirstView(inView) {
    const { hadFirstView } = this.state;
    /* eslint-disable-next-line no-unused-vars */
    const { onFirstView, children, className, ...args } = this.props;

    if (!hadFirstView && inView === true) {
      try {
        onFirstView(args);
      } catch (err) {
        clientError(err);
      } finally {
        this.setState({ hadFirstView: true });
      }
    }
  }

  render() {
    const { children } = this.props || <div />;
    return (
      <InView
        onChange={this.toggleHadFirstView}
        className={this.props.className}
      >
        {children}
      </InView>
    );
  }
}

FirstInView.defaultProps = {
  onFirstView: () => {},
  className: ''
};

FirstInView.propTypes = {
  onFirstView: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node
};

FirstInView.displayName = 'FirstInView';

export default FirstInView;
